/*
  RK search modal controller (Graff-clone).
  Open/close the sheet, rotate the Collections campaign card, and swap the
  discovery content for a 4-column suggestion grid while typing - powered
  by Shopify's native /search/suggest.json (no app): min 3 chars, 250ms
  debounce, 8 product suggestions (square image, serif name, price),
  "View All Results" carries the query through to /search.

  Performance: the snippet renders into every page, so the slides and the
  "Most Viewed" tiles arrive with their URLs parked in data-src/data-srcset
  and are promoted to src by hydrate() on the FIRST open only. The typed
  suggestion grid is built here and sets src directly, which is fine because
  it is only ever created after the visitor types.
*/
(function () {
  function init() {
    var overlay = document.querySelector('[data-rk-search]');
    if (!overlay || overlay.dataset.rkSearchReady === '1') return;
    overlay.dataset.rkSearchReady = '1';
    var input = overlay.querySelector('[data-rk-search-input]');
    var defaultZone = overlay.querySelector('[data-rk-search-default]');
    var results = overlay.querySelector('[data-rk-search-results]');
    var list = overlay.querySelector('[data-rk-search-list]');
    var allLink = overlay.querySelector('[data-rk-search-all]');
    var empty = overlay.querySelector('[data-rk-search-empty]');
    var closeBtn = overlay.querySelector('[data-rk-search-close]');
    var lastFocus = null;
    var slideTimer = null;
    var hydrated = false;

    /* "Most Viewed": shuffle the server-rendered pool, keep 6.
       Runs at init, i.e. BEFORE hydrate(), so the 12 discarded tiles leave the
       DOM without ever costing a request. */
    var grid = overlay.querySelector('[data-rk-search-grid]');
    if (grid && grid.children.length > 6) {
      var tiles = Array.prototype.slice.call(grid.children);
      for (var i = tiles.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = tiles[i]; tiles[i] = tiles[j]; tiles[j] = t;
      }
      tiles.forEach(function (tile, idx) {
        if (idx < 6) grid.appendChild(tile); else grid.removeChild(tile);
      });
    }

    /* The overlay ships on every page, so its imagery is held in data-src and
       only promoted to src the first time the sheet is opened. Nothing here is
       fetched on page load. */
    function hydrate() {
      if (hydrated) return;
      hydrated = true;
      overlay.querySelectorAll('img[data-src]').forEach(function (img) {
        var sizes = img.getAttribute('data-sizes');
        var srcset = img.getAttribute('data-srcset');
        /* sizes and srcset must land before src so the browser picks the right candidate */
        if (sizes) { img.setAttribute('sizes', sizes); img.removeAttribute('data-sizes'); }
        if (srcset) { img.setAttribute('srcset', srcset); img.removeAttribute('data-srcset'); }
        img.setAttribute('src', img.getAttribute('data-src'));
        img.removeAttribute('data-src');
      });
    }

    /* Collections card crossfade */
    function startSlides() {
      var slides = overlay.querySelectorAll('[data-rk-search-slides] .rk-search__slide');
      if (slides.length < 2 || slideTimer) return;
      var i = 0;
      slideTimer = window.setInterval(function () {
        i = (i + 1) % slides.length;
        slides.forEach(function (s, j) {
          s.classList.toggle('is-active', j === i);
          s.setAttribute('aria-hidden', j === i ? 'false' : 'true');
          s.tabIndex = j === i ? 0 : -1;
        });
      }, 5000);
    }
    function stopSlides() {
      if (slideTimer) { clearInterval(slideTimer); slideTimer = null; }
    }

    function open() {
      hydrate();
      lastFocus = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      startSlides();
      window.setTimeout(function () { input.focus(); }, 350); /* after the 0.3s visibility transition - focusing a hidden element is a no-op */
    }
    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      stopSlides();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.querySelectorAll('[data-rk-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    function showDefault() {
      results.hidden = true;
      defaultZone.hidden = false;
    }

    var timer = null;
    var seq = 0;
    function render(products, q) {
      list.innerHTML = '';
      defaultZone.hidden = true;
      results.hidden = false;
      empty.hidden = products.length > 0;
      products.forEach(function (p) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'rk-search__result';
        a.href = p.url;
        var img = document.createElement('img');
        img.className = 'rk-search__result-img';
        img.width = 341;
        img.height = 341;
        img.loading = 'lazy';
        img.alt = '';
        var src = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        // A srcset, not one fixed 480px file: the results tile is ~341px wide on a
        // laptop, i.e. ~680 device pixels on a Retina screen, so a single 480 was soft.
        if (src) {
          var sized = function (w) {
            try { var u = new URL(src, location.href); u.searchParams.set('width', w); return u.toString(); }
            catch (e) { return src; }
          };
          img.sizes = '(min-width: 990px) 21vw, 50vw';
          img.srcset = [400, 600, 800, 1000, 1200].map(function (w) { return sized(w) + ' ' + w + 'w'; }).join(', ');
          img.src = sized(800);
        }
        a.appendChild(img);
        var name = document.createElement('span');
        name.className = 'rk-search__result-name';
        name.textContent = p.title;
        a.appendChild(name);
        var n = Number(p.price);
        if (!isNaN(n) && n > 0) {
          var price = document.createElement('span');
          price.className = 'rk-search__result-price';
          price.textContent = (window.RK && window.RK.formatMoney ? window.RK.formatMoney(n) : '$' + n.toLocaleString()) + ' ' + (window.RK && window.RK.taxNote || '');
          a.appendChild(price);
        }
        li.appendChild(a);
        list.appendChild(li);
      });
      allLink.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'search?q=' + encodeURIComponent(q);
    }

    function suggest(q) {
      var mySeq = ++seq;
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (mySeq !== seq) return; // stale response
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, q);
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (timer) clearTimeout(timer);
      if (q.length < 3) {
        showDefault();
        return;
      }
      timer = setTimeout(function () { suggest(q); }, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e && e.target ? e.target : document); });
})();
